import {Component, Input, OnInit} from '@angular/core';
import {VideoObject} from '../../models/video-model';
import {environment} from '../../../environments/environment';
import {DataService} from '../../services/data.service';

@Component({
    selector: 'app-audio-player',
    templateUrl: './audio-player.component.html',
    styleUrls: ['./audio-player.component.scss']
})
export class AudioPlayerComponent implements OnInit {

    @Input() mediaData: VideoObject;

    constructor(public data: DataService) {

    }

    ngOnInit(): void {
    }

    getPosterUrl(): string {
        return environment.serverUrl + this.mediaData.poster;
    }


    onContextMenu($event: MouseEvent): void {
        $event.preventDefault();
    }

    onTimeUpdate(player: HTMLAudioElement): void {
        try {
            window.parent.postMessage({currentTime: player.currentTime, duration: player.duration}, '*');
        } catch (e) {
            console.log('Time message not sent');
            console.log(e);
        }

    }
}
